import { BadgeVariant, BadgeWithStatus } from '@property.com.au/ui-kit';
import { ComponentProps } from 'react';

export const isListingImage = (image: ListingImage | AerialImage): image is ListingImage =>
  'webpUri' in image || 'jpgUri' in image;

export interface ListingImage {
  alt: string;
  caption?: string | null;
  jpgUri: string;
  webpUri: string;
}

export interface AerialImage {
  alt: string;
  caption?: string | null;
  uri: string;
}

export interface Badge {
  text: string;
  variant: BadgeVariant;
}
export interface BadgeV2 {
  text: string;
  variant: ComponentProps<typeof BadgeWithStatus>['variant'];
}

export interface TitleWithSourceLevel {
  display?: string;
  sourceLevel?: number;
}
